const CONFIRMATION_DATA_INPUT_KEY = "__askRedoConfirmationData";
const CONFIRMATION_PROMPT_INPUT_KEY = "__askRedoConfirmationPrompt";

export interface AskRedoConfirmationData {
  confirmationData: unknown;
  confirmationPrompt?: string;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function withAskRedoConfirmationData(
  input: unknown,
  confirmationData: unknown,
  confirmationPrompt: string | undefined,
): unknown {
  if (confirmationData === undefined && confirmationPrompt === undefined) {
    return input;
  }

  const enriched: Record<string, unknown> = isRecord(input)
    ? { ...input }
    : { value: input };

  if (confirmationData !== undefined) {
    enriched[CONFIRMATION_DATA_INPUT_KEY] = confirmationData;
  }
  if (confirmationPrompt !== undefined) {
    enriched[CONFIRMATION_PROMPT_INPUT_KEY] = confirmationPrompt;
  }

  return enriched;
}

export function readAskRedoConfirmationData(
  input: unknown,
): AskRedoConfirmationData | undefined {
  if (!isRecord(input) || !(CONFIRMATION_DATA_INPUT_KEY in input)) {
    return undefined;
  }

  const prompt = input[CONFIRMATION_PROMPT_INPUT_KEY];
  return {
    confirmationData: input[CONFIRMATION_DATA_INPUT_KEY],
    confirmationPrompt: typeof prompt === "string" ? prompt : undefined,
  };
}
